import { Booking } from 'components/EventCalendar/types';
import { refTable } from 'components/TrainingPlan/TrainingPlanHelpers';
import moment from 'moment';
import { useTranslation } from 'react-i18next';

interface Props {
    booking: Booking;
    /** Off where the list carries a status column of its own, which already states the cancellation. */
    showCancellation?: boolean;
}

/** The event's date: date on top, time and repetition below. */
export const DatesComponent = ({ booking, showCancellation = true }: Props) => {
    const { t } = useTranslation('bookings');
    const event = booking.event;
    const startDate = event.start ? moment(event.start).format('dd, DD.MM.YY') : t('common.noDate');
    const dateRangeText =
        event.start && event.repeat_until
            ? t('booking.list.dates.range', { start: startDate, until: moment(event.repeat_until).format('DD.MM.YY') })
            : startDate;

    const timeText = event.start_time
        ? t('booking.list.dates.timeRange', {
              start: refTable.times[event.start_time],
              end: refTable.times[event.end_time]
          })
        : null;
    const scheduleText = [timeText, event.repeat_period].filter(Boolean).join(' · ');

    return (
        <div className="tw-flex tw-min-w-0 tw-flex-col tw-leading-5">
            <span className="tw-truncate tw-tabular-nums" title={dateRangeText}>
                {dateRangeText}
            </span>
            {scheduleText && (
                <span className="tw-truncate tw-text-xs tw-leading-4 tw-text-accents-6" title={scheduleText}>
                    {scheduleText}
                </span>
            )}
            {showCancellation &&
                (booking.cancelled_at ? (
                    <span className="tw-text-xs tw-leading-4 tw-text-error">
                        {t('booking.list.dates.cancelledAt', { date: moment(booking.cancelled_at).format('l LT') })}
                    </span>
                ) : (
                    event.cancellable_until && (
                        <span className="tw-text-xs tw-leading-4 tw-text-accents-6">
                            {t('booking.list.dates.cancellableUntil', {
                                date: moment(event.cancellable_until).format('l LT')
                            })}
                        </span>
                    )
                ))}
        </div>
    );
};
